import { getTopOffer } from 'webReservations/reservationDetails/apiHelpers';
import { Reservation } from 'webReservations/reservations/apiHelpers';
import { useQuery } from '@tanstack/react-query';

export const useTopOffer = (
  reservation?: Pick<Reservation, 'id' | 'status'>,
) => {
  return useQuery({
    queryKey: ['reservations', reservation?.id, 'top-offer'],
    queryFn: async () => getTopOffer(reservation?.id as string),
    enabled: Boolean(reservation) && reservation?.status === 'active',
    initialData: {},
  });
};
